import classNames from "classnames";

export default function Checkbox({
  label,
  tooltip,
  labelClassName = "",
  id,
  containerClassName,
  className = "w-[13px] h-[13px] mr-2",
  ...props
}) {
  return (
    <>
      <div className={containerClassName}>
        <input
          type="checkbox"
          id={id}
          className={classNames(
            "appearance-none checked:bg-light-purple border-2 border-light-purple",
            "checked:border-transparent hover:cursor-pointer",
            "shrink-0",
            className
          )}
          {...props}
        />
        <div className="inline">
          <label
            htmlFor={id}
            className={`text-light-purple inline ${labelClassName}`}
          >
            {label}
          </label>
          {tooltip && <div className="inline md:pl-0.5">{tooltip}</div>}
        </div>
      </div>
    </>
  );
}
